import { createSelector } from 'reselect'
import { State } from 'interfaces/state'
import { createVisibleInsightsByPlacementSelector } from 'selectors/insightsSelectors'
import { getInsightNotification } from 'helpers/notificationsHelpers'
import { Insight } from 'interfaces/insights'

const notificationsAppSelector = (state: State) =>
  state.app.notifications

export const notificationsAreExpandedSelector = createSelector(
  notificationsAppSelector,
  (state) => state.isExpanded
)

export const uiNotificationsSelector = createSelector(
  notificationsAppSelector,
  (state) => state.notifications
)

const insightNotificationsSelector = createSelector(
  createVisibleInsightsByPlacementSelector<Insight>(),
  (insights) =>
    insights.map(getInsightNotification)
)

export const globalNotificationsSelector = createSelector(
  createVisibleInsightsByPlacementSelector<Insight, true>('all_notifications'),
  (insights) => insights.map(getInsightNotification),
)

export const notificationsSelector = createSelector(
  insightNotificationsSelector,
  globalNotificationsSelector,
  uiNotificationsSelector,
  (insightNotifications, globalNotifications, trackerNotifications) => [
    ...insightNotifications,
    ...globalNotifications,
    ...trackerNotifications,
  ],
)
